import * as identify from "utils/treeUtils";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";

export const getLocalPath = (
  node: NodeApi<Node> | null,
  path: string = "",
): string => {
  if (!node) {
    return path;
  }
  const { data } = node;

  if (identify.isRoot(data)) {
    return `${data.folderName} / ${path}`;
  }

  if (!identify.isAnyFolder(data)) {
    return getLocalPath(node.parent, path);
  }

  if (path === "") {
    return getLocalPath(node.parent, `${data.folderName}`);
  }
  return getLocalPath(node.parent, `${data.folderName} / ${path}`);
};
